'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf(_constants.WEEKDAYS);


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-dates/lib/shapes/DayOfWeekShape.js
// module id = 167
// module chunks = 168707334958949